import { poll } from 'lib/poll';
import { SelfServiceAPI } from 'apis';

const acceptCancellationQuote = async (bookingId: string, cancellationId: string) => {
  await SelfServiceAPI.acceptCancellation({ bookingId, cancellationId });

  const acceptedResult = await poll({
    requestFn: () => SelfServiceAPI.getCancellation({ bookingId, cancellationId }),
    isFinished: (result) => result.cancellation.state !== 'ACCEPTING',
  });

  if (!['ACCEPTED', 'FAILED', 'BLOCKED'].includes(acceptedResult.cancellation.state)) {
    throw Error(`Unexpected cancellation state "${acceptedResult.cancellation.state}"`);
  }

  return acceptedResult.cancellation;
};

export default acceptCancellationQuote;
